import { traceEvent } from '@wk/wk-gatherer';
import { getQueryParams } from '@wk/wk-uni-lib';
import { useAtomValue } from 'jotai';

import { accountAtom, ipInfoAtom, studentListAtom } from '../store/user-store';
import { getDeviceInfo } from '../utils/device';

const getStudentType = (
  subscribeUser?: boolean,
  gs20User?: boolean,
): string => {
  if (subscribeUser) {
    return '订阅学员';
  }
  if (gs20User) {
    return 'GS2.0';
  }
  return '常规';
};

const getStudyStatus = (student: any) => {
  let chineseHour = '';
  let mathHour = '';
  let englishHour = '';

  if (student?.courseUnits) {
    for (const item of student.courseUnits) {
      if (item.subject === 'CHINESE') {
        chineseHour = `${item.remaining}`;
      } else if (item.subject === 'MATH') {
        mathHour = `${item.remaining}`;
      } else if (item.subject === 'ENGLISH') {
        englishHour = `${item.remaining}`;
      }
    }
  }

  return {
    中文: chineseHour,
    数学: mathHour,
    英文: englishHour,
  };
};

export function useTraceCommonParams() {
  const studentList = useAtomValue(studentListAtom);

  const student = studentList?.content?.[0];
  const account = useAtomValue(accountAtom)?.content;
  const ipInfo = useAtomValue(ipInfoAtom)?.content;

  // 获取通用埋点参数（用于 data-expose-data 等场景）
  const getCommonParams = () => {
    const { deviceType, os, deviceBrand } = getDeviceInfo();
    const { triggerPvid, triggerEvent, dsSource } = getQueryParams();

    return {
      deviceType,
      os,
      deviceBrand,
      studentId: student?.uuid,
      accountId: account?.uuid,
      studentType: getStudentType(student?.subscribeUser, student?.gs20User),
      studentTypev2: student?.newTags?.length ? student.newTags : ['normalStu'],
      studyStatus: getStudyStatus(student),
      subjectPayStatus: {
        中文: student?.chinesePayStatus,
        数学: student?.mathPayStatus,
        英文: student?.englishPayStatus,
      },
      country: ipInfo?.country,
      city: ipInfo?.city,
      triggerPvid,
      dsSource,
      triggerEvent,
      RewardsBalance: student?.userPointAccount?.pointsBalance,
      studentCode: student?.code,
    };
  };

  const traceWithCommonParams = (params: Record<string, any>) => {
    traceEvent({
      data: {
        ...getCommonParams(),
        ...params,
      },
    });
  };

  return { traceWithCommonParams, getCommonParams, isTraceReady: !!ipInfo };
}
